import { create } from "zustand"

interface WeeklyActivitiesState {
  isNextWeek: boolean
  setIsNextWeek: (isNextWeek: boolean) => void
}

export const useWeeklyActivities = create<WeeklyActivitiesState>((set) => ({
  isNextWeek: false,
  setIsNextWeek: (isNextWeek: boolean) =>
    set(() => ({
      isNextWeek,
    })),
}))

export default useWeeklyActivities.getState()
